<template>
  <div class="inscription-delete-modal">
    <div class="inscription-delete-modal__content">
      <img
        class="inscription-delete-modal__image"
        :src="modal.imageSrc"
        :alt="modal.title"
      />

      <div>
        <p
          class="inscription-delete-modal__title"
          v-text="modal.title"
        />
        <p
          class="inscription-delete-modal__message"
          v-text="modal.message"
        />
      </div>

      <div>
        <el-button
          type="secondary"
          class="inscription-delete-modal__button"
          @click="onCancel"
        >
          <span v-text="modal.cancelButtonCaption" />
        </el-button>

        <el-button
          type="primary"
          class="inscription-delete-modal__button"
          @click="onDelete"
        >
          <span v-text="modal.deleteButtonCaption" />
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

import { i18n } from '@shared/i18n'

import inscriptionDeleteImage from '@/assets/inscription-delete.svg'

export default {
  name: 'inscription-delete-modal',
  data() {
    return {
      modal: {
        imageSrc: inscriptionDeleteImage,
        title: i18n('entities.inscription.remove.title'),
        message: i18n('entities.inscription.remove.message'),
        deleteButtonCaption: i18n('common.remove'), 
        cancelButtonCaption: i18n('common.cancel'), 
      },
    }
  },
  computed: {
    ...mapGetters({
      inscriptionDeleteModalCallback: 'inscriptionDeleteModalCallback',
    }),
  },
  methods: {
    ...mapMutations({
      setInscriptionDeleteModalVisible: 'setInscriptionDeleteModalVisible',
      setInscriptionDeleteModalCallback: 'setInscriptionDeleteModalCallback',
    }),
    onCancel() {
      this.setInscriptionDeleteModalVisible(false)
    },
    onDelete() {
      if (typeof this.inscriptionDeleteModalCallback !== 'function') return
      this.inscriptionDeleteModalCallback()
      this.setInscriptionDeleteModalCallback(null)
      this.setInscriptionDeleteModalVisible(false)
    },
  }
}
</script>

<style lang="scss" scoped>
.inscription-delete-modal {
  @include modal-mixin;

  &__content {
    display: grid;
    grid-template-columns: 500px;
    grid-template-rows: 80px auto 40px;
    grid-gap: 32px;
    align-items: center;
    justify-items: center;
    justify-content: center;
    margin: 0 auto;
  }

  &__image {
    width: auto;
    height: 100%;
    margin: 20px 0 10px;
  }

  &__title {
    font-size: 24px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    text-transform: none;
    color: #686868;
  }

  &__message {
    font-size: 20px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: rgba(73, 73, 73, 0.41);
    word-break: break-word;
    margin-top: 4px;
  }

  &__button {
    width: 140px;

    &.el-button--primary,
    &.el-button--primary:active,
    &.el-button--primary:focus {
      color: #ffffff;
      background-color: #ee7266;
      border-color: #ee7266;
    }

    &.el-button--secondary,
    &.el-button--secondary:active,
    &.el-button--secondary:focus {
      color: #ee7266;
      background-color: #ffffff;
      border-color: #ee7266;
    }
  }
}
</style>
